import { $, Swiper } from "../shared/globals.js";

export function createLogoSwiperFeature() {
    const instances = [];

    function init() {
        if (!Swiper) return;

        $(".logo-swiper").each(function() {
            const $slider = $(this);
            if ($slider.data("logoSwiperInstance")) {
                return;
            }

            if (!$slider.find(".swiper-slide").length) {
                return;
            }

            $slider.addClass("swiper logo-group-swiper");

            const swiper = new Swiper(this, {
                slidesPerView: 8,
                slidesPerGroup: 1,
                spaceBetween: 44,
                speed: 600,
                loop: false,
                rewind: true,
                allowTouchMove: true,
                simulateTouch: true,
                followFinger: true,
                grabCursor: true,
                touchStartPreventDefault: false,
                watchOverflow: true,
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: false,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 2.5,
                        spaceBetween: 44,
                    },
                    480: {
                        slidesPerView: 4.5,
                        spaceBetween: 44,
                    },
                    768: {
                        slidesPerView: 6,
                        spaceBetween: 44,
                    },
                    992: {
                        slidesPerView: 8,
                        spaceBetween: 44,
                    },
                },
            });

            $slider.data("logoSwiperInstance", swiper);
            instances.push(swiper);
        });
    }

    function destroy() {
        instances.forEach((instance) => {
            instance.destroy(true, true);
        });

        instances.length = 0;

        $(".logo-swiper")
            .removeData("logoSwiperInstance")
            .removeClass("logo-group-swiper");
    }

    return {
        init,
        destroy,
    };
}
